import config from '@config';
import { pick } from 'lodash/fp';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'schedules';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();

  const getDays = ({ eventId }) => dataSource.get(`${BASE_PATHNAME}/${eventId}/days-for-schedule`).json();

  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();

  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  const save = async ({ id, values }) => (id ? update({ id, values }) : create({ values }));

  const remove = ({ id }) => dataSource.post(`${BASE_PATHNAME}/drop`, { json: { id } }).json();

  return {
    getList: getDefaultListHandler({
      transformFilter: pick(['countryId', 'eventId', 'eventIdWa']),
      url: BASE_PATHNAME,
      dataSource,
    }),

    getById,

    create,

    update,

    remove,

    save,

    getDays,

    getEmptyList: getDefaultEmptyList,
  };
};
